import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Badge, Avatar, Input, Skeleton } from "antd";
import "./ChatCard.css";
import { getImage } from "../../../../utilities/storageOperations/downloadURL";
import ReceivedBidsCard from "./components/ReceivedBidsCard/ReceivedBidsCard";
import BidAcceptedCard from "./components/BidAcceptedCard/bidAccepted";
import CardParent from "./components/CardParent";
import InterviewStatusCards from "./components/InterviewStatusCard.js/interviewStatusCard";
import { useSelector } from "react-redux";
import RatingsCard from "./components/RatingsCard/ratingsCard";
import ProfileSubmittedCard from "./components/ProfileSubmittedCard";
import { OfferCards } from "./components/OfferCard";
import { OnBillingCard } from "./components/onBillingCard";
import moment from "moment";
import { CandidateCancelledCard } from "./components/CandidateCancelledCard";
import AttachmentContainer from "./components/fileAttachment";
import Loader from "../../../../components/Loading/Loader";
import { WS } from "../../../../webSocket/defaultSocket";

export const ChatCard = React.memo(
  ({
    setFavCard,
    chatDetails,
    loadChat,
    setLoadChat,
    jobDetails,
    conversationId,
    records,
    SourceName,
    SourceId,
    Index,
  }) => {
    const [offerCard, setOfferCard] = useState({});
    const [history, setHistory] = useState();
    const [Retractedby, setRetractedBy] = useState("");
    const [test, setTest] = useState(false);
    const [tal, setTal] = useState();
    const [firstRecord, SetFirstRecord] = useState();
    const msgContainer = useRef();
    const [chatFavcard, setChatfavCard] = useState(false);
    const chatLoading = useSelector(state=> state.messagesReducer.historyLoading)
    const flag = useSelector((state) => state.messagesReducer.flag);
    var cache = {},
      character,
      e = document.createElement("div");

    const msgtxt = (html) => {
      return html?.replace(/([&][^&; ]+[;])/g, function (entity) {
        character = cache[entity];
        if (!character) {
          e.innerHTML = entity;
          if (e.childNodes[0])
            character = cache[entity] = e.childNodes[0].nodeValue;
          else character = "";
        }
        return character;
      });
    };

    useEffect(() => {
      if (chatDetails?.length > 0) {
        SetFirstRecord(chatDetails[0]);
      }
      setTimeout(() => {
        setLoadChat(false);
      }, 300);

      if (
        chatDetails?.length > 0 &&
        chatDetails[0].Status === "Retracted Bid" &&
        Retractedby === "Emp"
      ) {
        setHistory([chatDetails[0]]);
      } else {
        if (chatDetails?.length > 0) setHistory([...chatDetails].reverse());
        if(chatDetails?.length > 0){
          const filteredIds = chatDetails.filter(obj => obj.ReadAt == null && obj.RecipientProfileId == userProfile?.AccountId).map(obj => obj._id);
          if(filteredIds.length){
            for (let i = 0; i < filteredIds.length; i++) {
              WS.sendMessage(
                JSON.stringify({
                  action: "sendMessage",
                  users:
                    chatDetails[0]?.RecipientUser?.AccountId ==
                    userProfile?.AccountId
                      ? chatDetails[0]?.SenderUser?.AccountId
                      : chatDetails[0]?.RecipientUser?.AccountId, // chatDetails[0].RecipientUser.AccountId == userProfile?.AccountId //     ? chatDetails[0].SenderUser.AccountId //     : chatDetails[0].RecipientUser.AccountId,
                  data: "",
                  SourceId: chatDetails[0].SourceId,
                  Type: 'TAL',
                  ConversationId: chatDetails[0]?.ConversationId,
                  // onModel: "skill_listings",
                  SourceTypeId: chatDetails[0]?.SourceTypeId,
                  SecondarySourceId: chatDetails[0]?.SecondarySourceId,
                  SourceName: chatDetails[0]?.GigCard?.Title,
                  SecondarySourceTypeId: chatDetails[0]?.SecondarySourceTypeId,
                  HasAttachments: false,
                  attachments: null,
                  GigTitle:'Gig Title',
                  type: "readMessage",
                  MessageId:filteredIds[i]
                })
              );
            }
          }
        }
      }
    }, [chatDetails,flag]);

    useEffect(() => {
      if (history && history?.length > 0) {
        if (history[history?.length - 1]?.SourceTypeId === 2) {
          setTal(history[history?.length - 1]?.ProposalCard?.ProfileId);
        } else {
          setTal(history[history?.length - 1]?.SkillListingCard?.CreatedBy);
        }
      }
    }, [history]);

    // const loading = useSelector(state => state.messagesReducer.historyLoading)

    let userProfile = JSON.parse(localStorage.getItem("userProfile"));

    const chatfavcardhandler = (e) => {
      setChatfavCard(e);
    };

    useEffect(() => {
      setFavCard(chatFavcard);
    }, [chatfavcardhandler]);

    const editResponse = useSelector(
      (state) => state.messagesReducer.editOfferRes
    );

    useEffect(() => {
      setTest(true);
    }, [history]);

    console.log('history', history)

    return (
      <>
        {
          chatLoading ? 
          <div style={{height:'100%'}}>
            <Loader />
          </div>:
          <div
          className="chatcard"
          aria-details={chatDetails?.length > 1 && "more-than-one-msg"}
          ref={msgContainer}
        >
          
          {loadChat ? (
            <div className="InnerChatCont">
              <Row className="spaceTop">
                <div className="left">
                  <CardParent htmlValue={false}>
                    <Skeleton active />
                  </CardParent>
                </div>
                <div className="right" style={{ marginTop: "3%" }}>
                  <CardParent htmlValue={false}>
                    <Skeleton active />
                  </CardParent>
                </div>
              </Row>
            </div>
          ) : (
            history?.map((items,index) => {
              if (items?.SenderLabels !== null) {
                var nonNullIndex = history
                  .slice(0, index + 1)
                  .reduce((count, currentItem) => count + (currentItem?.SenderLabels !== null), 0);
              }
              let currentDate = moment();
              let convDateCheck = false;
              let lastIndexCheck = false;
          
              if (index == history.length - 1) {
                convDateCheck = true;
                lastIndexCheck = true;
              }
              else{
                if(moment(items?.Created).format("MMMM Do YYYY")!= moment(history[index+1]?.Created).format("MMMM Do YYYY")){
                  convDateCheck = true;    
                }
                else{ 
                  convDateCheck = false;
                }
              }
              return (
                <div className="InnerChatCont" key={items?._id}>
                  {
                  convDateCheck ? 
                  (
                    <div className="conv-Date">{
                      moment(items?.Created).diff(currentDate,'days')==0?
                      <div style={{marginLeft:'10%',marginTop: !lastIndexCheck ? '5%' : null,color:'#a3a3a3'}}>Today</div>
                      :moment(items?.Created).diff(currentDate,'days')==-1?
                      <div style={{marginLeft:'7%', marginTop: !lastIndexCheck ? '5%' : null, color:'#a3a3a3'}}>Yesterday</div>
                      :<div style={{marginTop: !lastIndexCheck ? '5%' : null, color:'#a3a3a3'}}>{moment(items?.Created).format("MMMM D, YYYY")}
</div>
                      }</div>
                  ) : null}
                  <Row className="spaceTop">
                    <div
                      className={
                        // userProfile._id == items?.SenderUser._id &&
                        // items?.RecipientUser._id != userProfile._id
                        //   ? items?.SourceTypeName == "Gigs"
                        //     ? "left"
                        //     : items?.SourceTypeName == "SkillListing"
                        //     ? "right"
                        //     : ""
                        //   : "left"
                        tal ?
                          items?.SenderUser?.AccountId ?
                            tal !== items?.SenderUser?.AccountId //items?.SenderUser?.AccountId
                              ? "right"
                              : "left"
                            :
                            tal !== items?.SenderProfileId ? 'right' : 'left'
                          :
                          items?.SenderUser?.AccountId ?
                            userProfile?.AccountId ===
                              items?.SenderUser?.AccountId //items?.SenderUser?.AccountId
                              ? "right"
                              : "left"
  
                            :
                            userProfile?.AccountId === items?.SenderProfileId ? 'right' : 'left'
                      }
                    >
                      {items?.SecondarySourceTypeId == 3 ||
                        items?.SecondarySourceTypeId == 4 ? (
                        items?.Status == "Accepted Bid" ||
                          items?.Status == "Bid Finalized" ||
                          items?.Status == "Declined Bid" ||
                          items?.Status == "Offer Declined" ||
                          items?.Status == "Terminated" ? (
                          <CardParent
                            status={items?.Status}
                            htmlValue={false}
                            Created={items?.Created}
                            data={items}
                          >
                            <BidAcceptedCard
                              data={items}
                              status={items?.Status}
                              MessageText={items?.MessageText}
                              source={items?.SourceTypeId}
                              bid_id={
                                items?.BidCard?.BidId
                                  ? items?.BidCard?.BidId
                                  : items?.ProposalCard?.ProposalId
                              }
                              SkillListing_id={
                                items?.SkillListingCard?.SkillListingId
                              }
                            />
                          </CardParent>
                        ) : items?.Status == "On Billing" ||
                          items?.Status == "Off Billing" ||
                          items?.Status == "Billing Extended" ? (
                          <CardParent
                            htmlValue={false}
                            btns={true}
                            status={items?.Status}
                            Created={items?.Created}
                            source={items?.SourceTypeId}
                            data={items}
                            jobDetails={jobDetails}
                          >
                            <OnBillingCard data={items} status={items?.Status} />
                          </CardParent>
                        ) : items?.Status == "New Bid" ||
                          items?.Status == "Retracted Bid" ? (
                          items?.SecondarySourceTypeId === 3 ? (
                            <ReceivedBidsCard
                              setfavCard={chatfavcardhandler}
                              records={records}
                              SourceName={SourceName}
                              SourceId={SourceId}
                              setFavCard={setFavCard}
                              status={items?.Status}
                              name={
                                items?.SourceTypeId == 2
                                  ? items?.RecipientUser?.UserName
                                  : items?.SourceTypeId == 1
                                    ? items?.SenderUser?.UserName
                                    : "User Name"
                              }
                              // img={
                              //   items?.SourceTypeId == 2
                              //     ? getProfilePic("candidate", items)
                              //     : items?.SourceTypeId == 1
                              //     ? getProfilePic("emp", items)
                              //     : ""
                              // }
                              cardDetails={items?.BidCard ?? items?.ProposalCard}
                              SkillListingCard={
                                items?.SkillListingCard && items?.SkillListingCard
                              }
                              GigCard={items?.GigCard}
                              source={items?.SourceTypeId}
                              Created={items?.Created}
                              data={items}
                              setRetractedBy={setRetractedBy}
                              Index={Index}
                              nonNullIndex={nonNullIndex}
                            />
                          ) : (
                            <ReceivedBidsCard
                              setfavCard={chatfavcardhandler}
                              records={records}
                              SourceName={SourceName}
                              SourceId={SourceId}
                              setFavCard={setFavCard}
                              status={items?.Status}
                              name={
                                items?.SourceTypeId == 2
                                  ? items?.RecipientUser?.UserName
                                  : items?.SourceTypeId == 1
                                    ? items?.SenderUser?.UserName
                                    : "User Name"
                              }
                              // img={
                              //   items?.SourceTypeId == 2
                              //     ? getProfilePic("candidate", items)
                              //     : items?.SourceTypeId == 1
                              //     ? getProfilePic("emp", items)
                              //     : ""
                              // }
                              cardDetails={items?.ProposalCard}
                              SkillListingCard={
                                items?.SkillListingCard && items?.SkillListingCard
                              }
                              GigCard={items?.GigCard}
                              source={items?.SourceTypeId}
                              Created={items?.Created}
                              data={items}
                              setRetractedBy={setRetractedBy}
                              Index={Index}
                              nonNullIndex={nonNullIndex}
                            />
                          )
                        ) : items?.Status == null ? (
                          <>
                            <CardParent
                              htmlValue={true}
                              threebtns={false}
                              attachments={items?.Attachments}
                              Created={items?.Created}
                              data={items}
                            >
                              {items?.MessageText}
                              {/* <div
                                dangerouslySetInnerHTML={{
                                  __html: msgtxt(items?.MessageText),
                                }}
                              ></div> */}
                            </CardParent>
  
                            {/* <CardParent htmlValue={false} ratings={true}>
                                  <RatingsCard
                                    Rating={items?.SecondarySourceTypeName}
                                    Ratings_data={items?.Ratings}
                                    items={items}
                                  />
                                </CardParent> */}
                          </>
                        ) : items?.Status == "Profile Submitted" ? (
                          <CardParent
                            htmlValue={false}
                            threebtns={true}
                            bid_id={
                              items?.BidCard?.BidId && items?.BidCard?.BidId
                            }
                            SkillListing_id={
                              items?.SkillListingCard?.SkillListingId
                            }
                            data={items}
                          // interviewCardID
                          >
                            <ProfileSubmittedCard data={items} />
                          </CardParent>
                        ) : items.Status == "Off Billing" ||
                          items.Status == "Billing Extended" ? (
                          <CardParent
                            htmlValue={false}
                            btns={true}
                            data={items}
                            status={items?.Status}
                            Created={items?.Created}
                          >
                            <OnBillingCard data={items} status={items?.Status} />
                          </CardParent>
                        ) : items?.Status == "Offer Pending" ||
                          items?.Status == "Hired" ? (
                          <CardParent
                            htmlValue={false}
                            status={items?.Status}
                            data={items}
                            source={items?.SourceTypeId}
                            OfferCards={
                              editResponse?._id
                                ? editResponse.offers
                                : items?.OfferCard
                            }
                            Created={items?.Created}
                          >
                            <OfferCards
                              status={items?.Status}
                              OfferCards={
                                editResponse?._id
                                  ? editResponse.offers
                                  : items?.OfferCard
                              }
                              nonNullIndex={nonNullIndex}
                            />
                          </CardParent>
                        ) : items?.Status == "Offer Accepted" ? (
                          <CardParent
                            htmlValue={false}
                            status={"Offer Accepted"}
                            source={items?.SourceTypeId}
                            OfferCards={
                              editResponse?._id
                                ? editResponse.offers
                                : items?.OfferCard
                            }
                            data={items}
                          >
                            <OfferCards
                              status={items?.Status}
                              source={items?.SourceTypeId}
                              OfferCards={
                                editResponse?._id
                                  ? editResponse.offers
                                  : items?.OfferCard
                              }
                              items={items}
                              nonNullIndex={nonNullIndex}
                            />
                          </CardParent>
                        ) : items?.Status == "Rating" ? (
                          <CardParent
                            Ratings_data={items?.BidCard ?? items?.ProposalCard}
                            htmlValue={false}
                            ratings={true}
                            data={items}
                            Created={items?.Created}
                            status={items?.Status}
                          >
                            <RatingsCard
                              Rating={items?.SecondarySourceTypeId}
                              Ratings_data={
                                items?.BidCard
                                  ? items?.BidCard?.rating
                                  : items?.ProposalCard?.rating
                              }
                              items={items}
                            />
                          </CardParent>
                        ) : (
                          (items?.Status == "Candidate Cancelled" ||
                            items?.Status == "Candidate Terminated") && (
                            <CardParent
                              htmlValue={false}
                              btns={true}
                              status={items?.Status}
                              Created={items?.Created}
                              data={items}
                            >
                              <CandidateCancelledCard
                                data={items}
                                status={items?.Status}
                              />
                            </CardParent>
                          )
                        )
                      ) : items?.SecondarySourceTypeId == 4 ? (
                        <ReceivedBidsCard
                          setfavCard={chatfavcardhandler}
                          setFavCard={setFavCard}
                          records={records}
                          SourceName={SourceName}
                          SourceId={SourceId}
                          status={items?.Status}
                          name={
                            items?.SourceTypeId == 2
                              ? items?.RecipientUser?.UserName
                              : items?.SourceTypeId == 1
                                ? items?.SenderUser?.UserName
                                : "User Name"
                          }
                          // img={
                          //   items?.SourceTypeId == 2
                          //     ? getProfilePic("candidate", items)
                          //     : items?.SourceTypeId == 1
                          //     ? getProfilePic("emp", items)
                          //     : ""
                          // }
                          cardDetails={items?.ProposalCard}
                          SkillListingCard={
                            items?.SkillListingCard && items?.SkillListingCard
                          }
                          GigCard={items?.GigCard}
                          source={items?.SourceTypeId}
                          Created={items?.Created}
                          data={items}
                          setRetractedBy={setRetractedBy}
                          Index={Index}
                          nonNullIndex={nonNullIndex}
                        />
                      ) : items?.SecondarySourceTypeId == null ? (
                        <CardParent Created={items?.Created} data={items}>
                          {items?.MessageText}
                        </CardParent>
                      ) : (
                        items?.SecondarySourceTypeId == 5 && (
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <CardParent
                              chatDetails={chatDetails}
                              index={nonNullIndex} 
                              Created={items?.Created}
                              btns={true}
                              data={items}
                              status={items?.Status}
                              htmlValue={false}
                              bid_id={
                                items?.BidCard?.BidId && items?.BidCard?.BidId
                              }
                              SkillListing_id={
                                items?.SkillListingCard?.SkillListingId
                              }
                              interviewCardID={
                                items?.InterviewCard?.InterviewId &&
                                items?.InterviewCard?.InterviewId
                              }
                            >
                              <InterviewStatusCards
                                status={items?.Status}
                                index={nonNullIndex}
                                InterviewCard={
                                  items?.InterviewCard && items?.InterviewCard
                                }
                                accepted={true}
                                BidStatus={items?.Status}
                                MessageText={items?.MessageText}
                                items={items}
                                bidType={
                                  firstRecord?.BidCard ? "bid" : "Proposal"
                                }
                              />
                            </CardParent>
  
                            {/* 
                            < CardParent htmlValue={false}>
                              <InterviewStatusCards
                                status={items?.Status}
                                accepted={true}
                              // InterviewCard={items?.InterviewCard && items?.InterviewCard}
                              // BidStatus={items?.Status}
                              // items={items}
                              />
                            </CardParent> */}
                          </div>
                        )
                      )}
                    </div>
                  </Row>
                </div>
              );
            })
          )}
        </div>
        }
      </>
    );
  }
);
